import authApi from '@/api/axios-api';

const SSO_AUTH_URL = 'auth/sso';
const SSO_AVAILABILITY = 'auth/available';

export const sso = {
    namespaced: true,
    state: {
        email: null,
        showLoginFields: false,
    },
    mutations: {
        setEmail(state, email) {
            state.email = email;
        },
        setShowLoginFields(state, value) {
            state.showLoginFields = value;
        },
    },
    actions: {
        async checkSSO({ state, commit, dispatch }) {
            if (!state.email) {
                return { ok: false, reason: 'empty_email' };
            }

            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            if (!emailRegex.test(state.email)) {
                return { ok: false, reason: 'invalid_email' };
            }

            try {
                const response = await authApi.post(SSO_AVAILABILITY, { email: state.email });
                if (response.data?.data) {
                    await dispatch('initiateSSO');
                    return { ok: true, sso: true };
                }
                commit('setShowLoginFields', true);
                return { ok: true, sso: false };
            } catch (error) {
                // Client sees no reason — backend logs cover availability failures
                commit('setShowLoginFields', true);
                return { ok: true, sso: false };
            }
        },

        async initiateSSO({ state }) {
            if (!state.email) {
                return { ok: false };
            }

            try {
                const response = await authApi.post(SSO_AUTH_URL, {
                    email: state.email,
                    platform: 'pha',
                });

                const url = response.data?.url;
                if (url) {
                    window.location.href = url;
                    return { ok: true };
                }
                return { ok: false, reason: 'no_url' };
            } catch (error) {
                return { ok: false, reason: 'request_failed' };
            }
        },
    },
};
